import { requestAuthPost } from "./authInstance";

export const checkLoyalty = async (code) => {
  if (!code) throw new Error("Kode loyalty tidak boleh kosong.");

  const response = await requestAuthPost("loyalty-cards/get-eligible", {
    code,
  });

  if (response.error) {
    throw new Error(response.errorMessage || "Loyalty tidak dapat digunakan.");
  }

  const cards = Array.isArray(response.data)
    ? response.data
    : response.data?.data;
  const loyaltyCard = Array.isArray(cards) ? cards[0] : null;
  if (!loyaltyCard) throw new Error("Loyalty tidak ditemukan.");
  if (loyaltyCard.isEligibleToRedeem === false) {
    throw new Error("Loyalty sudah tidak dapat ditukarkan.");
  }

  return loyaltyCard;
};

export const redeemLoyalty = async (payload) => {
  const response = await requestAuthPost(
    "loyalty-card-transactions/redeemLoyalty",
    payload,
  );

  if (response.error) {
    throw new Error(response.errorMessage || "Loyalty gagal ditukarkan.");
  }

  return response.data;
};
